import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Button, TextField } from '@mui/material';

import './UserCodeForm.scss';

function UserCodeForm({ onSubmit, userCode }) {

  function validate(values) {
    const errors = {};
  
    if (!values.userCode) {
      errors.userCode = 'Código inválido';
    }
  
    return errors;
  }

  return (
    <Formik
      initialValues={{
        userCode: userCode || ''
      }}
      validate={validate}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="form">
          <Field
            as={TextField}
            className="field"
            name="userCode"
            label="Código do usuário"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="userCode" component="div" />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="button"
            disabled={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Enviando código do usuário ...' : 'Enviar código'}
          </Button>
        </Form>
      )}
    </Formik>
  );
}

export default UserCodeForm;